import * as ArrayUtil from '../core/ArrayUtil';
import * as ObjectUtil from '../core/ObjectUtil';
import { doubleQuote } from '../core/StringUtil';
export var show = function (f) {
    return ({ show: f });
};
export var showConst = function (s) { return show(function () { return s; }); };
export var showStringCtor = show(function (x) { return String(x); });
export var showJsonStringify = show(function (x) { return JSON.stringify(x); });
export var showUndefined = showConst('undefined');
export var showNull = showConst('null');
export var showBoolean = showStringCtor;
export var showNumber = showStringCtor;
export var showString = show(function (x) { return doubleQuote(x); });
export var showFunction = showConst('function() {...}');
export var showArray = function (showA) { return show(function (xs) {
    return '[' + ArrayUtil.map(xs, showA.show).join(', ') + ']';
}); };
export var showRecord = function (showA) { return show(function (rec) {
    return '{' + ObjectUtil.toTuples(rec).map(function (_a) {
        var k = _a[0], v = _a[1];
        return doubleQuote(k) + ': ' + showA.show(v);
    }).join(', ') + '}';
}); };
//# sourceMappingURL=Show.js.map